// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   Service detail page — supplementary styles
   Additive layer on top of tc-project-style1 and existing utility
   classes (color-666, color-orange1, bg-orange1, fsz-*, butn, tags).
-------------------------------------------------------------------*/

.tc-project-style1.detail-style2 .main-img {
  height: 460px;
  border-radius: 20px;
  overflow: hidden;
}

.tc-project-style1.detail-style2 .main-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 991px) {
  .tc-project-style1.detail-style2 .main-img {
    height: 360px;
  }
}

@media (max-width: 575px) {
  .tc-project-style1.detail-style2 .main-img {
    height: 260px;
  }
}

/* ---------- Overview ---------- */
/* ---------- Overview ---------- */
.detail-style2 .overview-container {
  padding-top: 60px;
  text-align: center;
}

.detail-style2 .overview-body {
  max-width: 100%;
  margin: 0 auto;
}

.detail-style2 .overview-body .lead-text {
  position: relative;
  padding-top: 26px;
  font-size: 26px;
  font-weight: 500;
  line-height: 1.6;
  color: #1a1a1a;
  letter-spacing: 0.2px;
  margin: 0 0 32px;
}

.detail-style2 .overview-body .lead-text::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  border-radius: 2px;
  background-color: var(--color-orange1, #b06a3f);
}

.detail-style2 .overview-body .text {
  font-size: 17px;
  line-height: 1.9;
  margin: 0 0 22px;
}

.detail-style2 .overview-body .text:last-child {
  margin-bottom: 0;
}

@media (max-width: 767px) {
  .detail-style2 .overview-container {
    padding-top: 60px;
  }

  .detail-style2 .overview-body .lead-text {
    padding-top: 20px;
    font-size: 21px;
  }
}

/* ---------- Gallery ---------- */
.detail-style2 .gallery-section {
  padding-top: 100px;
}

.detail-style2 .gallery-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 400px;
  grid-auto-flow: row dense;
  gap: 18px;
}

.detail-style2 .gallery-grid .gallery-item {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  display: block;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.07);
}

.detail-style2 .gallery-grid .gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.7s ease;
}

/* dark-to-transparent wash so the expand icon always reads clearly */
.detail-style2 .gallery-grid .gallery-item::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.55) 0%,
    rgba(0, 0, 0, 0) 45%
  );
  opacity: 0;
  transition: opacity 0.4s ease;
  z-index: 1;
}

/* expand affordance, bottom-left */
.detail-style2 .gallery-grid .gallery-item::after {
  content: "\\2197";
  position: absolute;
  left: 18px;
  bottom: 18px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  color: #111;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity 0.35s ease, transform 0.35s ease;
  z-index: 2;
}

.detail-style2 .gallery-grid .gallery-item:hover {
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.14);
}

.detail-style2 .gallery-grid .gallery-item:hover img {
  transform: scale(1.08);
}

.detail-style2 .gallery-grid .gallery-item:hover::before,
.detail-style2 .gallery-grid .gallery-item:hover::after {
  opacity: 1;
  transform: translateY(0);
}

/* first image is the feature tile */
.detail-style2 .gallery-grid .gallery-item:first-child {
  grid-column: span 2;
  grid-row: span 2;
}

/* when the gallery has exactly 4 images, the 4th (last) tile would
   otherwise leave an empty cell — stretch it across the bottom row
   so the grid always reads as a solid, intentional layout */
.detail-style2 .gallery-grid .gallery-item:nth-child(4):last-child {
  grid-column: span 2;
}

@media (max-width: 991px) {
  .detail-style2 .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 220px;
  }
  .detail-style2 .gallery-grid .gallery-item:first-child {
    grid-column: span 2;
    grid-row: span 1;
    aspect-ratio: 16 / 9;
  }
  .detail-style2 .gallery-grid .gallery-item:nth-child(4):last-child {
    grid-column: span 2;
  }
}

@media (max-width: 575px) {
  .detail-style2 .gallery-grid {
    grid-template-columns: 1fr;
    grid-auto-rows: 300px;
  }
  .detail-style2 .gallery-grid .gallery-item:first-child,
  .detail-style2 .gallery-grid .gallery-item:nth-child(4):last-child {
    grid-column: span 1;
  }
}

/* ---------- Checklist grid ---------- */
.detail-style2 .checklist-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 24px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.detail-style2 .checklist-grid li {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 22px 24px;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 14px;
  line-height: 1.5;
  overflow: hidden;
  transition: background-color 0.3s ease, border-color 0.3s ease,
    box-shadow 0.3s ease, transform 0.3s ease;
}

/* thin accent bar that slides in on hover */
.detail-style2 .checklist-grid li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: var(--color-orange1, #b06a3f);
  transform: scaleY(0);
  transform-origin: bottom;
  transition: transform 0.35s ease;
}

.detail-style2 .checklist-grid li:hover {
  background: #fff;
  border-color: rgba(0, 0, 0, 0.1);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.08);
  transform: translateY(-4px);
}

.detail-style2 .checklist-grid li:hover::before {
  transform: scaleY(1);
}

.detail-style2 .checklist-grid .check-icon {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
  transition: transform 0.3s ease;
}

.detail-style2 .checklist-grid li:hover .check-icon {
  transform: scale(1.08) rotate(-8deg);
}

@media (max-width: 767px) {
  .detail-style2 .checklist-grid {
    grid-template-columns: 1fr;
  }
}

/* ---------- Other services ---------- */
.detail-style2 .other-services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.detail-style2 .other-service-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 22px 24px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  text-decoration: none;
  color: inherit;
  font-weight: 600;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.detail-style2 .other-service-card:hover {
  background-color: rgba(0, 0, 0, 0.04);
  transform: translateY(-3px);
}

.detail-style2 .other-service-card i {
  flex: 0 0 auto;
  font-size: 16px;
}

@media (max-width: 767px) {
  .detail-style2 .other-services-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/innerpage/service_detail/service-detail.css"],"names":[],"mappings":"AAAA;;;;oEAIoE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,mCAAmC;AACnC,mCAAmC;AACnC;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,qEAAqE;AACrE;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;GAIC;EACD,UAAU;EACV,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,2BAA2B;EAC3B,oDAAoD;EACpD,UAAU;AACZ;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;4DAE4D;AAC5D;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;IACrC,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;EACA;;IAEE,mBAAmB;EACrB;AACF;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB;6CAC2C;AAC7C;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,+CAA+C;EAC/C,oBAAoB;EACpB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ------------------------------------------------------------------\n   Service detail page — supplementary styles\n   Additive layer on top of tc-project-style1 and existing utility\n   classes (color-666, color-orange1, bg-orange1, fsz-*, butn, tags).\n-------------------------------------------------------------------*/\n\n.tc-project-style1.detail-style2 .main-img {\n  height: 460px;\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n.tc-project-style1.detail-style2 .main-img img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n@media (max-width: 991px) {\n  .tc-project-style1.detail-style2 .main-img {\n    height: 360px;\n  }\n}\n\n@media (max-width: 575px) {\n  .tc-project-style1.detail-style2 .main-img {\n    height: 260px;\n  }\n}\n\n/* ---------- Overview ---------- */\n/* ---------- Overview ---------- */\n.detail-style2 .overview-container {\n  padding-top: 60px;\n  text-align: center;\n}\n\n.detail-style2 .overview-body {\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.detail-style2 .overview-body .lead-text {\n  position: relative;\n  padding-top: 26px;\n  font-size: 26px;\n  font-weight: 500;\n  line-height: 1.6;\n  color: #1a1a1a;\n  letter-spacing: 0.2px;\n  margin: 0 0 32px;\n}\n\n.detail-style2 .overview-body .lead-text::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 0;\n  transform: translateX(-50%);\n  width: 60px;\n  height: 3px;\n  border-radius: 2px;\n  background-color: var(--color-orange1, #b06a3f);\n}\n\n.detail-style2 .overview-body .text {\n  font-size: 17px;\n  line-height: 1.9;\n  margin: 0 0 22px;\n}\n\n.detail-style2 .overview-body .text:last-child {\n  margin-bottom: 0;\n}\n\n@media (max-width: 767px) {\n  .detail-style2 .overview-container {\n    padding-top: 60px;\n  }\n\n  .detail-style2 .overview-body .lead-text {\n    padding-top: 20px;\n    font-size: 21px;\n  }\n}\n\n/* ---------- Gallery ---------- */\n.detail-style2 .gallery-section {\n  padding-top: 100px;\n}\n\n.detail-style2 .gallery-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-auto-rows: 400px;\n  grid-auto-flow: row dense;\n  gap: 18px;\n}\n\n.detail-style2 .gallery-grid .gallery-item {\n  position: relative;\n  border-radius: 16px;\n  overflow: hidden;\n  display: block;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.07);\n}\n\n.detail-style2 .gallery-grid .gallery-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.7s ease;\n}\n\n/* dark-to-transparent wash so the expand icon always reads clearly */\n.detail-style2 .gallery-grid .gallery-item::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.55) 0%,\n    rgba(0, 0, 0, 0) 45%\n  );\n  opacity: 0;\n  transition: opacity 0.4s ease;\n  z-index: 1;\n}\n\n/* expand affordance, bottom-left */\n.detail-style2 .gallery-grid .gallery-item::after {\n  content: \"\\2197\";\n  position: absolute;\n  left: 18px;\n  bottom: 18px;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.95);\n  color: #111;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  opacity: 0;\n  transform: translateY(10px);\n  transition: opacity 0.35s ease, transform 0.35s ease;\n  z-index: 2;\n}\n\n.detail-style2 .gallery-grid .gallery-item:hover {\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.14);\n}\n\n.detail-style2 .gallery-grid .gallery-item:hover img {\n  transform: scale(1.08);\n}\n\n.detail-style2 .gallery-grid .gallery-item:hover::before,\n.detail-style2 .gallery-grid .gallery-item:hover::after {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* first image is the feature tile */\n.detail-style2 .gallery-grid .gallery-item:first-child {\n  grid-column: span 2;\n  grid-row: span 2;\n}\n\n/* when the gallery has exactly 4 images, the 4th (last) tile would\n   otherwise leave an empty cell — stretch it across the bottom row\n   so the grid always reads as a solid, intentional layout */\n.detail-style2 .gallery-grid .gallery-item:nth-child(4):last-child {\n  grid-column: span 2;\n}\n\n@media (max-width: 991px) {\n  .detail-style2 .gallery-grid {\n    grid-template-columns: repeat(2, 1fr);\n    grid-auto-rows: 220px;\n  }\n  .detail-style2 .gallery-grid .gallery-item:first-child {\n    grid-column: span 2;\n    grid-row: span 1;\n    aspect-ratio: 16 / 9;\n  }\n  .detail-style2 .gallery-grid .gallery-item:nth-child(4):last-child {\n    grid-column: span 2;\n  }\n}\n\n@media (max-width: 575px) {\n  .detail-style2 .gallery-grid {\n    grid-template-columns: 1fr;\n    grid-auto-rows: 300px;\n  }\n  .detail-style2 .gallery-grid .gallery-item:first-child,\n  .detail-style2 .gallery-grid .gallery-item:nth-child(4):last-child {\n    grid-column: span 1;\n  }\n}\n\n/* ---------- Checklist grid ---------- */\n.detail-style2 .checklist-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px 24px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.detail-style2 .checklist-grid li {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 22px 24px;\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 14px;\n  line-height: 1.5;\n  overflow: hidden;\n  transition: background-color 0.3s ease, border-color 0.3s ease,\n    box-shadow 0.3s ease, transform 0.3s ease;\n}\n\n/* thin accent bar that slides in on hover */\n.detail-style2 .checklist-grid li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background-color: var(--color-orange1, #b06a3f);\n  transform: scaleY(0);\n  transform-origin: bottom;\n  transition: transform 0.35s ease;\n}\n\n.detail-style2 .checklist-grid li:hover {\n  background: #fff;\n  border-color: rgba(0, 0, 0, 0.1);\n  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.08);\n  transform: translateY(-4px);\n}\n\n.detail-style2 .checklist-grid li:hover::before {\n  transform: scaleY(1);\n}\n\n.detail-style2 .checklist-grid .check-icon {\n  flex: 0 0 auto;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);\n  transition: transform 0.3s ease;\n}\n\n.detail-style2 .checklist-grid li:hover .check-icon {\n  transform: scale(1.08) rotate(-8deg);\n}\n\n@media (max-width: 767px) {\n  .detail-style2 .checklist-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ---------- Other services ---------- */\n.detail-style2 .other-services-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n.detail-style2 .other-service-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 22px 24px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 14px;\n  text-decoration: none;\n  color: inherit;\n  font-weight: 600;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n}\n\n.detail-style2 .other-service-card:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n  transform: translateY(-3px);\n}\n\n.detail-style2 .other-service-card i {\n  flex: 0 0 auto;\n  font-size: 16px;\n}\n\n@media (max-width: 767px) {\n  .detail-style2 .other-services-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
